<div class="mct-flex mct-col" >
  <div>
    <label>
      {{ 'profiles.edit.member-activity.member-activity-label' | translate | titlecase }}
    </label>
    <select class="form-control"  [(ngModel)]="memberActivity.ActivityTypeId" [disabled]="isReadOnly" (change)="activitySelected($event.target.value)">
      <option [value]="0">{{ 'common.select' | translate | titlecase }}</option>
      <option *ngFor="let activityType of activityTypes" (select)="activitySelected(activityType)" [value]="activityType.ActivityTypeID">
        {{ activityType.ActivityType }}
      </option>
    </select>
  </div>
  <div class="mct-flex mct-col" >
    <label>
      {{ 'profiles.edit.member-activity.member-activity-date-label' | translate | titlecase }}
    </label>
    <wl-date-selector [disabled] = "isReadOnly" [(ngModel)]="memberActivity.ActivityDate"></wl-date-selector>
  </div>
  <div>
    <label>
      {{ 'common.description' | translate | titlecase }}
    </label>
    <textarea class="form-control" [disabled]="isReadOnly" [(ngModel)]="memberActivity.Descr"></textarea>
  </div>
  <div>
    <label>
      {{ 'common.value' | translate | titlecase }}
    </label>
    <input type="text" class="form-control" [disabled]="isReadOnly" [(ngModel)]="memberActivity.ActivityValue" />
  </div>
  <div>
    <label>
      {{ 'profiles.edit.member-activity.external-id-label' | translate | titlecase }}
    </label>
    <input type="text" class="form-control" [disabled]="isReadOnly" [(ngModel)]="memberActivity.ExternalId" />
  </div>
  <div>
    <label>
      {{ 'profiles.edit.member-activity.activity-duration-period' | translate | ucfirst }}
    </label>
    <div class="mct-flex mct-row mct-gap-27"  >
      <div class="mct-flex mct-col" >
        <wl-date-selector [disabled] = "isReadOnly" [(ngModel)]="memberActivity.ActivityStartDate"></wl-date-selector>
        <label>
          {{ 'common.start-date' | translate | titlecase }}
        </label>
      </div>
      <div class="mct-flex mct-col" >
        <wl-date-selector [disabled] = "isReadOnly" [(ngModel)]="memberActivity.ActivityEndDate"></wl-date-selector>
        <label>
          {{ 'common.end-date' | translate | titlecase }}
        </label>
      </div>
    </div>
  </div>
</div>
